import { defineMessages } from 'react-intl'

export default defineMessages({
  in: {
    id: 'components.TansactionFilter.in',
    defaultMessage: 'Income',
    description: 'in',
  },
  out: {
    id: 'components.TansactionFilter.out',
    defaultMessage: 'Payout',
    description: 'out',
  },
  transactionTypes: {
    id: 'components.TansactionFilter.transactionTypes',
    defaultMessage: 'Transaction Types',
    description: 'Transaction Types',
  },
  payMethod: {
    id: 'components.TansactionFilter.payMethod',
    defaultMessage: 'Payment Method',
    description: 'Payment Method',
  },
  setAmountRange: {
    id: 'components.TansactionFilter.setAmountRange',
    defaultMessage: 'Set Amount Range',
    description: 'Set Amount Range',
  },
  min: {
    id: 'components.TansactionFilter.min',
    defaultMessage: 'Min',
    description: 'Min',
  },
  max: {
    id: 'components.TansactionFilter.max',
    defaultMessage: 'Max',
    description: 'Max',
  },
  aed: {
    id: 'components.TansactionFilter.aed',
    defaultMessage: 'AED',
    description: 'AED',
  },
})
